import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api_middleware";
import { UnrealAppBuild } from "../reducers/buildReducer";
import { UncutBuild } from "../reducers/buildReducer";

// Fetch all builds
export const fetchAllBuilds = createAsyncThunk(
  "builds/fetchAllBuilds",
  async () => {
    const response = await api(`builds/`, "GET", undefined, {
      usePixelsApi: true,
    });
    return response;
  }
);

// Fetch a single build by ID
export const fetchBuild = createAsyncThunk(
  "builds/fetchBuild",
  async (buildId: string) => {
    const response = await api(`builds/${buildId}`, "GET", undefined, {
      usePixelsApi: true,
    });
    return response;
  }
);

// Create/Update a build
export interface UpsertBuildParams {
  id: string;
  build_name: string;
  entries: Array<{
    platform: string;
    repository_type: string;
    key: string;
  }>;
  build_notes?: string | null;
}

export const upsertBuild = createAsyncThunk(
  "builds/upsertBuild",
  async (params: UpsertBuildParams) => {
    const response = await api(`builds/${params.id}`, "PUT", params, {
      usePixelsApi: true,
    });
    return response;
  }
);

export const deleteBuild = createAsyncThunk(
  "builds/deleteBuild",
  async (id: string) => {
    // The API endpoint: POST /v1/admin/pixels/builds/delete-build/:id
    const response = await api(`builds/delete-build/${id}`, "POST", null, {
      usePixelsApi: true,
    });
    return response as UnrealAppBuild
  }
);

export const fetchUnreleasedS3Builds = createAsyncThunk(
  "builds/fetchUnreleasedS3Builds",
  async () => {
    const res = await api(
      `unreleasedbuilds`,
      "GET",
      undefined,
      { usePixelsApi: true }
    );
    return res as UncutBuild[];
  }
);


export const createHotBuildFromS3 = createAsyncThunk(
  "builds/createHotBuildFromS3",
  async ({ uncutBuild, buildId }: { uncutBuild: UncutBuild; buildId?: string }) => {
    const id = buildId ?? crypto.randomUUID();

    const payload = {
      build_id: id,
      uncut_s3_linux_build: uncutBuild,
    };

    const created = await api(
      "builds/create_hot_build",
      "POST",
      payload,
      { usePixelsApi: true }
    );

    return created as UnrealAppBuild;
  }
);

export const promoteBuildToHot = createAsyncThunk(
  "builds/promoteBuildToHot",
  async (buildId: string) => {
    const response = await api(
      `builds/${buildId}/promote_to_hot`,
      "POST",
      null,
      { usePixelsApi: true }
    );
    return response as UnrealAppBuild;
  }
);